module.exports = __webpack_public_path__ + "static/media/client2.514ffa30.png";